import { useContext } from 'react';

import { _FormFieldContext } from '../contexts/FormFieldContext.js';
import type { SharedFormFieldContextProps } from '../contexts/FormFieldContext.js';

/**
 * @internal
 */
export const useFormFieldContext = (): SharedFormFieldContextProps =>
  useContext(_FormFieldContext);
